import React from 'react';
import { Trophy, Medal, Award } from 'lucide-react';
export const SalesLeaderboard = () => {
  const leaderboardData = [{
    id: 1,
    name: 'Michael Torres',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    sales: 58450,
    target: 60000,
    achievement: 97.4,
    isCurrentUser: false
  }, {
    id: 2,
    name: 'Sarah Johnson',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    sales: 48350,
    target: 60000,
    achievement: 80.6,
    isCurrentUser: true
  }, {
    id: 3,
    name: 'David Miller',
    avatar: 'https://randomuser.me/api/portraits/men/75.jpg',
    sales: 42680,
    target: 50000,
    achievement: 85.4,
    isCurrentUser: false
  }, {
    id: 4,
    name: 'Jennifer Williams',
    avatar: 'https://randomuser.me/api/portraits/women/65.jpg',
    sales: 38920,
    target: 50000,
    achievement: 77.8,
    isCurrentUser: false
  }, {
    id: 5,
    name: 'Robert Chen',
    avatar: 'https://randomuser.me/api/portraits/men/54.jpg',
    sales: 35780,
    target: 50000,
    achievement: 71.6,
    isCurrentUser: false
  }];
  const getRankIcon = (rank: number) => {
    switch (rank) {
      case 1:
        return <Trophy className="h-5 w-5 text-yellow-500" data-id="element-2301" />;
      case 2:
        return <Medal className="h-5 w-5 text-gray-400" data-id="element-2302" />;
      case 3:
        return <Medal className="h-5 w-5 text-amber-600" data-id="element-2303" />;
      default:
        return <span className="text-sm font-medium text-gray-500" data-id="element-2304">{rank}</span>;
    }
  };
  return <div className="bg-white rounded-lg shadow-md p-6" data-id="element-2305">
      <div className="flex justify-between items-center mb-6" data-id="element-2306">
        <h2 className="text-lg font-medium text-gray-800" data-id="element-2307">Sales Leaderboard</h2>
        <button className="text-sm text-blue-600 hover:text-blue-800" data-id="element-2308">
          View All
        </button>
      </div>
      <div className="space-y-4" data-id="element-2309">
        {leaderboardData.map((agent, index) => <div key={agent.id} className={`flex items-center p-3 rounded-lg ${agent.isCurrentUser ? 'bg-blue-50 border border-blue-100' : 'hover:bg-gray-50'}`} data-id="element-2310">
            <div className="flex items-center justify-center w-8 h-8 mr-4" data-id="element-2311">
              {getRankIcon(index + 1)}
            </div>
            <div className="flex items-center flex-1" data-id="element-2312">
              <img src={agent.avatar} alt={agent.name} className="w-10 h-10 rounded-full object-cover mr-3" data-id="element-2313" />
              <div data-id="element-2314">
                <p className={`font-medium ${agent.isCurrentUser ? 'text-blue-700' : 'text-gray-800'}`} data-id="element-2315">
                  {agent.name}
                  {agent.isCurrentUser && <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded" data-id="element-2316">
                      You
                    </span>}
                </p>
                <div className="flex items-center mt-1" data-id="element-2317">
                  <div className="w-24 bg-gray-200 rounded-full h-1.5 mr-2" data-id="element-2318">
                    <div className={`h-1.5 rounded-full ${index === 0 ? 'bg-yellow-500' : 'bg-blue-500'}`} style={{
                  width: `${agent.achievement}%`
                }} data-id="element-2319"></div>
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-2320">
                    ${agent.sales.toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
            {index < 3 && <div className="flex-shrink-0" data-id="element-2321">
                <div className={`
                  p-1.5 rounded-full
                  ${index === 0 ? 'bg-yellow-100' : index === 1 ? 'bg-gray-100' : 'bg-amber-100'}
                `} data-id="element-2322">
                  <Award className={`h-4 w-4 ${index === 0 ? 'text-yellow-600' : index === 1 ? 'text-gray-500' : 'text-amber-600'}`} data-id="element-2323" />
                </div>
              </div>}
          </div>)}
      </div>
    </div>;
};